import React from 'react'
import Popup from './Popup';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import ErrorBoundary from './ErrorBoundary';
import db from './db';
import TextEditor from './TextEditor';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
var tableColumnRender = require("./TableColumnRender.js")


// HubTestPopup component
export default class HubTestPopup extends React.Component {

// initialize the HubTestPopup Component
constructor(props) {
    super(props);
    this.state = {
        testObject:{ id:-1, events:[]},
        hubTestEventId:-1,
        eventPopup:false,
        selectedEvent:{"event_data":""},
        testObjectModified:false,
        testObjectPostNote:{id:-1}
};
}

componentDidUpdate(prevProps) {
    if(this.props.hubTest && this.state.hubTestId!==this.props.hubTest.id){
        //this.setState({
        //    testObject : { id:-1,test_status:"Please Wait...",test_note:"Please Wait...",analysis:[],events:[] }
        //                    ,hubTestId:-1
        //    })
        this.setState({
            hubTestId:this.props.hubTest.id
        });
    db.getHubTestEvent( this.props.hubTest.id
                            , this.props.securityObject
                            , (testList) => { 
                                this.setState({
                                    testObject : testList[0]
                                                                })
                            });
                            this.setState({
                                testObjectModified:false,
                                testObjectPostNote:{id:this.props.hubTest.id}
                            });
                            
    }
}

    // render
    render() {

        let title='';
        let testNote='';
        let testStatus="";
        if(this.props.hubTest){
            title=this.props.hubTest.test_descriptior+' - '+ this.props.hubTest.test_status;
            testNote=this.props.hubTest.test_note;
            testStatus=this.props.hubTest.test_status;
        }
        return(this.state.testObject) ? (
            <Popup className="hub-test-history-popup"  trigger={ this.props.hubTest }>
                <div className="align-right">
                    <button className="close-btn" onClick={() => this.closeHubTestPopup() }>Close</button>
                </div>
                <h3>{title}</h3>
                <pre>{testNote}</pre>
                <Tabs defaultIndex={this.props.tabIndex} >
                    <TabList>
                        <Tab>Notes</Tab>
                        <Tab>Analysis</Tab>
                        <Tab>Events</Tab>
                    </TabList>
                    <TabPanel >
                        Status:<input
                             onChange={this.updateHubTestInputValue.bind(this)}
                             defaultValue={testStatus}
                             name="test_status" id="test_status"
                             ></input>
                        <TextEditor  
                            className="NoteTextArea"
                            label="Note"
                            name="test_note" id="test_note" 
                            onChange={this.updateHubTestInputValue.bind(this)}
                            type="text"
                            defaultValue={testNote}>
                        </TextEditor>
                        <br />
                        <button disabled={!this.state.testObjectModified} className="" onClick={() => this.closeHubTestPopup() }>Close</button>
                        <button disabled={!this.state.testObjectModified} className="" onClick={() => this.saveHubTest(this) }>Save</button>               

                    </TabPanel>
                    <TabPanel >
                        <TableScrollbar height="500px">
                            <ErrorBoundary>
                                    <Table columns={[
                                                { title: '', key: 'fail', width :20, render:this.renderFail},
                                                { title: '', key: 'title', width :20 },
                                                { title: '', key: 'note', width :80, render:tableColumnRender.renderNoteSimple  }
                                            ]} 
                                                dataSource={this.state.testObject.analysis} 
                                        />
                            </ErrorBoundary>
                        </TableScrollbar>

                    </TabPanel>
                    <TabPanel >
                        <TableScrollbar height="500px">
                            <ErrorBoundary>
                                    <Table columns={[
                                                { title: 'Time', key: 'event_timestamp', width :7 }
                                                ,{title: 'Type', key: 'event_type', width :7 }
                                                ,{title: 'Status', key: 'event_status', width :7 }
                                                ,{title: 'Value', key: 'event_value', width :7 }
                                                ,{title: 'Query', key: 'event_query', width : 35}
                                                //,{title: 'Data', key: 'event_data', width :35 }
                                            ]} 
                                                dataSource={this.state.testObject.events} 
                                                onRowClick={this.viewEvent.bind(this)} 
                                                />
                            </ErrorBoundary>
                        </TableScrollbar>
                    </TabPanel>
                </Tabs>
                <Popup trigger={ this.state.eventPopup }>
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.setState({"eventPopup":false}) }>Close</button>
                    </div>
                    <TextEditor 
                        className="EventTextArea"
                        label="Event"
                        name="event" id="eventEditor" 
                        type="json"
                        defaultValue={this.state.selectedEvent.event_data}>
                    </TextEditor>
                </Popup>
            </Popup>  
        ):"";
    }

    viewEvent(rowData, rowIndex){
        this.setState({"eventPopup":true,
                       "selectedEvent":rowData })

    }

        // update value in post
        updateHubTestInputValue(evt){ 
            let testObjectPostNote = this.state.testObjectPostNote;
            testObjectPostNote.id=this.state.testObject.id;
            testObjectPostNote[evt.currentTarget.name] = evt.currentTarget.value;        
            this.setState({
                testObjectModified:true,
                testObjectPostNote:testObjectPostNote
            });  
        }

        closeHubTestPopup(){
            if(this.state.testObjectModified){
                if (window.confirm("The screen has been modified.  Would you like to exit without saving changes?") === true) {
                    this.props.closeHubTestPopup();
                    this.setState({
                        hubTestId:-1
                    })
                } 
            } else {
                this.props.closeHubTestPopup();
                this.setState({
                    hubTestId:-1
                })
            }
        }
    // save the note
    saveHubTest(thisApp){
        db.saveData( this.props.securityObject
                        , this.state.testObjectPostNote
                        ,"api/updateHubTest"
                        , function(){
                            //this.setNotePopupVisible(false);
                            thisApp.setState({
                                testObjectModified:false,
                                testObjectPostNote : {},
                                hubTestId:-1
                            }); 
                            thisApp.props.closeHubTestPopup(true);
                        });
    }    

    // display the note
    static renderTestNote(cellData, rowData, rowIndex){
        let array=[];

        // create note
        let noteStr=rowData.note;
        let note=React.createElement('pre',{ className:"render-note"}, noteStr  ); 
        array.push(note);

        // return div
        let div=React.createElement('div',{}, array );
        return div;    
    }

        // display the note
        static renderFail(cellData, rowData, rowIndex){
    
            // create note
            let noteStr="ok";
            if(rowData.fail){
                noteStr="fail"
            }
            return React.createElement('span',{},
                noteStr
                );   
        }
    
}

